import { environment as development } from './environment.dev';

// The app's peech-dev build (dev.app.getpeech.com): the development environment, pointed at
// peech-dev's web service and gateway instead of staging's.
export const environment = {
  ...development,
  serviceUrl: 'https://peech-web-service-inolythy4a-uc.a.run.app',
  gatewayUrl: 'https://peech-gateway-aehuo90f.uc.gateway.dev',
};
